import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 280px;
  min-width: 280px;
  border-right: var(--border-b-seed) solid var(--base-border-secondary);
  overflow: auto;
  z-index: var(--z-order-navigation);
`;

export const NavContainer = styled.nav`
  display: flex;
  flex-direction: column;
  gap: var(--layout-seed);
  padding: var(--layout-spoon) var(--layout-stamp);
`;

export const AccessibleGap = styled.div`
  margin-bottom: var(--layout-shoebox);
`;
